class TranslationError extends Error {
  public token?: string

  public constructor(message?: string, token?: string) {
    super(`Translation error. ${message || ''}`)
    this.token = token
  }
}

export default TranslationError
